<template>
    <div class="table-responsive results-table" v-if="sortedUsers.length > 0">
        <el-table ref="dataTable" :data="sortedUsers" style="width: 100%">
            <el-table-column prop="name" label="Name" sortable="custom" min-width="160">
                <template #default="scope">
                    <span class="text-capitalize"> {{ scope.row.name }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="rank" label="Rank" width="100" sortable="custom">
                <template #default="scope">
                    <span>{{ scope.row.rank }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="spo2" label="SPO2" width="100" sortable="custom">
                <template #default="scope">
                    <span>{{ scope.row.spo2 }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="steps" label="Steps" width="100" sortable="custom">
                <template #default="scope">
                    <span>{{ scope.row.steps }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="calories" label="Calories(kcal)" width="150" sortable="custom">
                <template #default="scope">
                    <span>{{ Math.round(scope.row.calories/1000) }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="minHr" label="Min HR" width="150" sortable="custom">
                <template #default="scope">
                    <span>{{ scope.row.minHr }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="avgHr" label="Avg HR" width="150" sortable="custom">
                <template #default="scope">
                    <span>{{ scope.row.avgHr }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="maxHr" label="Max HR" width="150" sortable="custom">
                <template #default="scope">
                    <span>{{ scope.row.maxHr }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="durationInSecs" label="Duration (secs)" width="150" sortable="custom">
                <template #default="scope">
                    <span>{{ scope.row.durationInSecs}}</span>
                </template>
            </el-table-column>
            <el-table-column v-if="false" label="" width="60">
                <template #default="scope">
                    <div class="d-flex">
                        <router-link target="_blank" :to="{
                            name: `User`,
                            params: { udid: scope.row.udid },
                            query: { date: getDate() },
                        }" exact>
                            <icon-user-info />
                        </router-link>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>

import IconUserInfo from "@/shared/Controls/Icons/IconUserInfo.vue";


export default {
    name: 'ChallengeResults',
    components: {
        IconUserInfo,
    },
    props: {
        users: {
            type: Array,
            required: true,
        },
    },
    mounted() {
        this.sortedUsers = this.sortByRank(this.users);
    },
    data() {
        return {
            chalengeDetails: null,
            sortedUsers: [],
        };
    },
    methods: {
        sortByRank(data) {
            return [...data].sort((a, b) => a.rank - b.rank);
        }
    }
};
</script>

<style scoped>
.form-container {
    max-width: 40rem;
    margin: auto;
    padding: 1rem;
    background-color: #283335;
    color: white;
    border-radius: 0.5rem;
}
.results-table {
    padding-left: 2rem;
    padding-right: 2rem;
    padding-top: 1rem;
}
</style>